// extracted by mini-css-extract-plugin
module.exports = {"root":"OFyDd_7f"};